'use client';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { IconChevronLeft } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React from 'react';
import { TelegramTransactionsTopUpVariantDto } from '@/generated';
import clsx from 'clsx';

type Props = {
  onClose: () => void;
  amounts: TelegramTransactionsTopUpVariantDto[];
  onSelect: (amount: number) => void;
  onBack?: () => void;
  showBack?: boolean;
};

const defaultIconLink = '/assets/images/coin-default-amount.png';

export const ChooseAmount: React.FC<Props> = ({ amounts, onClose, onSelect, onBack, showBack = false }) => {
  const t = useTranslations('monetization');
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-xl'>
        {showBack && (
          <Button
            variant='ghost'
            size='icon'
            onClick={onBack}
            className='absolute top-4 start-4 z-10 h-8 w-8 rounded-full hover:bg-transparent'
          >
            <IconChevronLeft className='text-text-primary' />
          </Button>
        )}
        <div className='flex flex-col gap-[12px] '>
          <DialogHeader className='items-center text-center'>
            <DialogTitle>{t('buy_coins')}</DialogTitle>
          </DialogHeader>

          <div className='flex items-center mt-[12px] self-center'>
            <Image src='/assets/images/buy_coins_promo.png' width={135} height={92} alt='' />
          </div>

          <div className='text-[16px] font-normal text-primary text-center'>
            {t('buy_coins_promo')}
            <span className='font-bold'>{t('buy_coins_promo_bold')}</span>
          </div>

          {amounts.map(({ amount, discountText, fiatAmount, currencySign }) => (
            <div
              onClick={() => {
                onSelect(amount);
              }}
              key={amount}
              className={clsx(
                'flex justify-between py-[12px] px-[8px] border-b border-solid border-primary-stroke-day cursor-pointer',
                { 'py-[10px]!': !!discountText },
              )}
            >
              <div className='flex gap-[8px] items-center'>
                <Image src={defaultIconLink} alt='' width={28} height={28} />

                <div className='flex flex-col items-start justify-center'>
                  <span className='font-semibold text-[18px]'>{amount}</span>
                  {discountText && <span className='text-red-day'>{discountText}</span>}
                </div>
              </div>

              <div className='py-[4px] px-[8px] rounded-[16px] bg-surface-neutral text-primary-green-day self-start'>
                {fiatAmount} {currencySign}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
